import { memo } from "react";
import { IconProps, defaultIconProps } from "./icon.props.type";
import SchoolIcon from "@mui/icons-material/School";
import { ThemeProvider, createTheme } from "@mui/material";

const GraduationIcon = ({
  color = defaultIconProps.color,
  size = defaultIconProps.size,
}: IconProps) => {
  const theme = createTheme({
    palette: { primary: { main: color } },
  });

  return (
    <ThemeProvider theme={theme}>
      <SchoolIcon style={{ width: size, height: size }} color="primary" />
    </ThemeProvider>
  );
};

export default memo(GraduationIcon);
